import React from 'react';
import Icon  from 'components/ui/icon';

const IconSuccess = () => {
  return <Icon icon="check" className="success" />;
};

export default IconSuccess;
